import { useAtomValue, useSetAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import * as React from 'react';

const MAX_RECENT_SEARCHES = 5;

/**
 * Atom to store the recent searches done by the user using AI Search / Lens.
 */
const recentAISearchesAtom = atomWithStorage<string[]>('recentAISearches', [], undefined, {
    getOnInit: true,
});

/**
 * List the recent searches done using AI Search / Lens.
 */
export function useRecentAISearches(): string[] {
    return useAtomValue(recentAISearchesAtom);
}

/**
 * Add a new search to the recent searches.
 */
export function useRegisterRecentAISearch(query: string) {
    const setRecentSearches = useSetAtom(recentAISearchesAtom);

    React.useEffect(() => {
        if (!query) {
            return;
        }

        setRecentSearches((recentSearches) => {
            if (recentSearches.includes(query)) {
                return recentSearches;
            }

            return [query, ...recentSearches.slice(0, MAX_RECENT_SEARCHES - 1)];
        });
    }, [query]);
}
